import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, from } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import { Product } from '../interfaces/product.model';
import { GeolocService } from '../providers/geoloc.service';
import { GoogleMapService } from '../providers/google-map.service';

@Injectable({ providedIn: 'root' })
export class NearbyStoresResolver implements Resolve<Product[]> {
    constructor(private geoSvc: GeolocService, private gmapSvc: GoogleMapService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return from(this.geoSvc.getCurrentLocation()).pipe(
            concatMap(location => {
                return this.gmapSvc.getNearbyStores(location.latitude, location.longitude);
            })
        );
    }
}
